import gql from 'graphql-tag';

const DELETE_REALTOR_APPOINTMENT = gql` 
  mutation deleteRealtorAppointment($input: RealtorAppointmentDeleteInput!, $sendEmail: Boolean!) {
    deleteRealtorAppointment(input: $input, sendEmail: $sendEmail) {
      message
      code
    }
  }
`;

export default DELETE_REALTOR_APPOINTMENT;